import Swiper, {Pagination, Navigation, Autoplay} from 'swiper';
var $ = require("jquery");

Swiper.use([Pagination, Navigation, Autoplay]);
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

const headerSwiperDesktop = new Swiper('header .swiper.desktop', {
  loop: true,
  autoplay: {
    delay: 5000,
  },
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: 'true'
  },

});

const headerSwiperMobile = new Swiper('header .swiper.mobile', {
  loop: true,
  autoplay: {
    delay: 5000,
  },
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: 'true'
  },
});

if ($("header .swiper.desktop").length === 1) {
  $('.swiper-wrapper').addClass("disabled");
  $('.swiper-pagination').addClass("disabled");
}

if ($("header .swiper.mobile").length === 1) {
  $('.swiper-wrapper').addClass("disabled");
  $('.swiper-pagination').addClass("disabled");
}
